import { render, staticRenderFns } from "./CreatePartnerDialog.vue?vue&type=template&id=d89f3e3a"
import script from "./CreatePartnerDialog.vue?vue&type=script&lang=js"
export * from "./CreatePartnerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports